"use client";

import { Card } from "@/components/ui/card";
import { useUser } from "@/context/useUser";
import { useActivePeriod } from "@/hooks/useActivePeriod";
import ParticipantPackageForm from "./ParticipantPackageForm";
import PicImportPackage from "./PicImportPackage";
import AdminPackage from "./AdminPackage";
import { CalendarX } from "lucide-react";

export default function StepPaket() {
    const { data: user, isLoading } = useUser();
    const { data: activePeriod, isLoading: loadingPeriod, isError } = useActivePeriod();

    if (isLoading || loadingPeriod) {
        return (
            <div className="mx-auto py-12 space-y-10 pt-0 w-full max-w-full">
                <Card className="border-0 shadow-lg bg-white dark:bg-gray-800 mb-3">
                    <div className="text-center space-y-2 py-4">
                        <h2 className="text-xl font-semibold text-gray-700 dark:text-gray-200">
                            Memuat daftar paket kegiatan...
                        </h2>
                        <p className="text-gray-500 dark:text-gray-400">
                            Mohon tunggu, sedang mengambil data paket.
                        </p>
                    </div>
                </Card>
                <div className="grid grid-cols-1 md:grid-cols-1 gap-6">
                    {[1, 2, 3].map((i) => (
                        <div
                            key={i}
                            className="animate-pulse overflow-hidden rounded-2xl bg-gradient-to-br from-gray-200/60 to-gray-100/30 dark:from-gray-700/40 dark:to-gray-800/50"
                        >
                            {/* Gambar */}
                            <div className="h-48 w-full bg-gray-300 dark:bg-gray-700" />

                            {/* Konten */}
                            <div className="p-5 space-y-3">
                                {/* Judul */}
                                <div className="h-5 w-2/3 bg-gray-300 dark:bg-gray-600 rounded" />
                                {/* Deskripsi */}
                                <div className="h-4 w-full bg-gray-300 dark:bg-gray-700 rounded" />
                                <div className="h-4 w-5/6 bg-gray-300 dark:bg-gray-700 rounded" />
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        );
    }

    if (!activePeriod || isError) {
        return (
            <div className="mx-auto w-full">
                <Card className="border-dashed border-2 shadow-none bg-white/90 dark:bg-gray-600">
                    <div className="flex flex-col items-center text-center p-10 space-y-5">

                        {/* Icon */}
                        <div className="flex h-16 w-16 items-center justify-center rounded-full bg-primary/10 text-primary">
                            <CalendarX className="h-8 w-8 text-yellow-600" />
                        </div>

                        {/* Title */}
                        <h2 className="text-xl font-semibold text-gray-800 dark:text-gray-200">
                            Tidak Ada Periode Aktif
                        </h2>

                        {/* Description */}
                        <p className="text-sm text-gray-500 dark:text-gray-400 max-w-md">
                            Saat ini belum ada periode kegiatan yang aktif.
                            Silakan menunggu hingga administrator membuka periode baru.
                        </p>

                        {/* Optional hint */}
                        <div className="text-xs text-gray-400">
                            Jika ini dirasa keliru, silakan hubungi pengelola sistem.
                        </div>
                    </div>
                </Card>
            </div>
        );
    }

    if (user?.role_id === 1) {
        return <AdminPackage user={user} activePeriod={activePeriod} />;
    }

    if (user?.role_id === 2) {
        return <ParticipantPackageForm user={user} activePeriod={activePeriod} />;
    }

    if (user?.role_id === 3) {
        return <PicImportPackage user={user} activePeriod={activePeriod} />;
    }

    return null;
}
